import { useQuery } from '@tanstack/react-query';
import { diagnosticService } from '../services';

export function useQualificationStatus() {
  return useQuery({
    queryKey: ['diagnostic', 'qualificationStatus'],
    queryFn: () => diagnosticService.getQualificationStatus(),
  });
}
